<template>
  <div :class="`comp-ly-buttons comp-ly-button${randomString}`">
    <jw-space>
      <template v-for="(b, i) in buttons" :key="i">
        <template v-if="i < buttonNumber">
          <!-- ---------------------公共按钮--所有对象都有的 S---------------------------->
          <!-- 编辑 -->
          <jw-button v-if="b.value == `${oem[entity]}:edit`" :disabled="b.disabled" @click="toAllEdit" type="text" size="small" :class="['normal-btn', { 'disabled-btn': b.disabled }]">
            <template #icon v-if="buttonIcons?.[`${oem[entity]}:edit`] && (buttonType?.[`${oem[entity]}:edit`] == 0 || buttonType?.[`${oem[entity]}:edit`] == 1)">
              <component :is="getComponentName('edit')" />
            </template>
            <template v-if="buttonType?.[`${oem[entity]}:edit`] == 0 || buttonType?.[`${oem[entity]}:edit`] == 2">
              {{ buttonTexts?.[`${oem[entity]}:edit`] }}
            </template>
          </jw-button>
          <!-- 复制 -->
          <jw-button v-if="b.value == `${oem[entity]}:copy`" type="text" size="small" :class="['normal-btn', { 'disabled-btn': b.disabled }]" @click="copyObject">
            <template #icon v-if="buttonIcons?.[`${oem[entity]}:copy`] && (buttonType?.[`${oem[entity]}:copy`] == 0 || buttonType?.[`${oem[entity]}:copy`] == 1)">
              <component :is="getComponentName('copy')" />
            </template>
            <template v-if="buttonType?.[`${oem[entity]}:copy`] == 0 || buttonType?.[`${oem[entity]}:copy`] == 2">
              {{ buttonTexts?.[`${oem[entity]}:copy`] }}
            </template>
          </jw-button>
          <!-- 转移 -->
          <jw-button v-if="b.value == `${oem[entity]}:transfer`" :disabled="b.disabled" type="text" size="small" :class="['normal-btn', { 'disabled-btn': b.disabled }]" @click="transferData">
            <template #icon v-if="buttonIcons?.[`${oem[entity]}:transfer`] && (buttonType?.[`${oem[entity]}:transfer`] == 0 || buttonType?.[`${oem[entity]}:transfer`] == 1)">
              <component :is="getComponentName('transfer')" />
            </template>
            <template v-if="buttonType?.[`${oem[entity]}:transfer`] == 0 || buttonType?.[`${oem[entity]}:transfer`] == 2">
              {{ buttonTexts?.[`${oem[entity]}:transfer`] }}
            </template>
          </jw-button>
          <!-- 分享 -->
          <template v-if="b.value == `${oem[entity]}:share`">
            <xl-tree-member-modal @cb="getVal" :tree="tree" :key="`${oem[entity]}:share`">
              <jw-button type="text" size="small" :class="['normal-btn', { 'disabled-btn': b.disabled }]" :loading="data.shareLoading">
                <template #icon v-if="buttonIcons?.[`${oem[entity]}:share`] && (buttonType?.[`${oem[entity]}:share`] == 0 || buttonType?.[`${oem[entity]}:share`] == 1)">
                  <component :is="getComponentName('share')" />
                </template>
                <template v-if="buttonType?.[`${oem[entity]}:share`] == 0 || buttonType?.[`${oem[entity]}:share`] == 2">
                  {{ buttonTexts?.[`${oem[entity]}:share`] }}
                </template>
              </jw-button>
            </xl-tree-member-modal>
          </template>
          <!-- 商机的特殊按钮逻辑 -->
          <template v-if="entity == 3">
            <!-- 华映 新增订单入口-->
            <jw-button v-if="b.value == `${oem[entity]}:addCallPayment`" :disabled="b.disabled" type="text" size="small" :class="['normal-btn', { 'disabled-btn': b.disabled }]" @click="openAddModal(1)">
              <template #icon v-if="buttonIcons?.[`${oem[entity]}:addCallPayment`] && (buttonType?.[`${oem[entity]}:addCallPayment`] == 0 || buttonType?.[`${oem[entity]}:addCallPayment`] == 1)">
                <component :is="getComponentName('addCallPayment')" />
              </template>
              <template v-if="buttonType?.[`${oem[entity]}:addCallPayment`] == 0 || buttonType?.[`${oem[entity]}:addCallPayment`] == 2">
                {{ buttonTexts?.[`${oem[entity]}:addCallPayment`] }}
              </template>
            </jw-button>
            <!-- 华映 新增合同入口 -->
            <jw-button v-if="b.value == `${oem[entity]}:addProtocol`" :disabled="b.disabled" @click="openAddModal(2)" type="text" size="small" :class="['normal-btn', { 'disabled-btn': b.disabled }]">
              <template #icon v-if="buttonIcons?.[`${oem[entity]}:addProtocol`] && (buttonType?.[`${oem[entity]}:addProtocol`] == 0 || buttonType?.[`${oem[entity]}:addProtocol`] == 1)">
                <component :is="getComponentName('addProtocol')" />
              </template>
              <template v-if="buttonType?.[`${oem[entity]}:addProtocol`] == 0 || buttonType?.[`${oem[entity]}:addProtocol`] == 2">
                {{ buttonTexts?.[`${oem[entity]}:addProtocol`] }}
              </template>
            </jw-button>
          </template>

          <!--  删除-->
          <jw-button v-if="b.value == `${oem[entity]}:delete`" :disabled="b.disabled" type="text" @click="deleteObject" size="small" :class="['normal-btn', { 'disabled-btn': b.disabled }]">
            <template #icon v-if="buttonIcons?.[`${oem[entity]}:delete`] && (buttonType?.[`${oem[entity]}:delete`] == 0 || buttonType?.[`${oem[entity]}:delete`] == 1)">
              <component :is="getComponentName('delete')" />
            </template>
            <template v-if="buttonType?.[`${oem[entity]}:delete`] == 0 || buttonType?.[`${oem[entity]}:delete`] == 2">
              {{ buttonTexts?.[`${oem[entity]}:delete`] }}
            </template>
          </jw-button>
          <!-- ---------------------特殊差异按钮--某个对象才有 ---------------------------------->
          <jw-button v-if="b.value == `${oem[entity]}:addRedReversal`" :disabled="b.disabled" type="text" size="small" :class="['normal-btn', { 'disabled-btn': b.disabled }]" @click="addRedReversal">
            <template #icon v-if="buttonIcons?.[`${oem[entity]}:addRedReversal`] && (buttonType?.[`${oem[entity]}:addRedReversal`] == 0 || buttonType?.[`${oem[entity]}:addRedReversal`] == 1)">
              <component :is="getComponentName('addRedReversal')" />
            </template>
            <template v-if="buttonType?.[`${oem[entity]}:addRedReversal`] == 0 || buttonType?.[`${oem[entity]}:addRedReversal`] == 2">
              {{ buttonTexts?.[`${oem[entity]}:addRedReversal`] }}
            </template>
          </jw-button>
          <!-- 销售线索 S -->
          <!-- 转化 -->
          <jw-button v-if="b.value == `${oem[entity]}:transform`" :disabled="b.disabled" type="text" size="small" :class="['normal-btn', { 'disabled-btn': b.disabled }]" @click="conversion">
            <template #icon v-if="buttonIcons?.[`${oem[entity]}:transform`] && (buttonType?.[`${oem[entity]}:transform`] == 0 || buttonType?.[`${oem[entity]}:transform`] == 1)">
              <component :is="getComponentName('transform')" />
            </template>
            <template v-if="buttonType?.[`${oem[entity]}:transform`] == 0 || buttonType?.[`${oem[entity]}:transform`] == 2">
              {{ buttonTexts?.[`${oem[entity]}:transform`] }}
            </template>
          </jw-button>
          <!-- 退回 -->
          <jw-button v-if="b.value == `${oem[entity]}:return`" :disabled="b.disabled" type="text" size="small" :class="['normal-btn', { 'disabled-btn': b.disabled }]" @click="returnClue">
            <template #icon v-if="buttonIcons?.[`${oem[entity]}:return`] && (buttonType?.[`${oem[entity]}:return`] == 0 || buttonType?.[`${oem[entity]}:return`] == 1)">
              <component :is="getComponentName('return')" />
            </template>
            <template v-if="buttonType?.[`${oem[entity]}:return`] == 0 || buttonType?.[`${oem[entity]}:return`] == 2">
              {{ buttonTexts?.[`${oem[entity]}:return`] }}
            </template>
          </jw-button>
          <!-- 销售线索 E -->
          <!-- 线索池S -->
          <jw-button v-if="b.value == `${oem[entity]}:receive`" :disabled="b.disabled" type="text" size="small" :class="['normal-btn', { 'disabled-btn': b.disabled }]" @click="collectionClue">
            <template #icon v-if="buttonIcons?.[`${oem[entity]}:receive`] && (buttonType?.[`${oem[entity]}:receive`] == 0 || buttonType?.[`${oem[entity]}:receive`] == 1)">
              <component :is="getComponentName('receive')" />
            </template>
            <template v-if="buttonType?.[`${oem[entity]}:receive`] == 0 || buttonType?.[`${oem[entity]}:receive`] == 2">
              {{ buttonTexts?.[`${oem[entity]}:receive`] }}
            </template>
          </jw-button>
          <jw-button v-if="b.value == `${oem[entity]}:allocation`" :disabled="b.disabled" type="text" size="small" :class="['normal-btn', { 'disabled-btn': b.disabled }]" @click="distributionClue">
            <template #icon v-if="buttonIcons?.[`${oem[entity]}:allocation`] && (buttonType?.[`${oem[entity]}:allocation`] == 0 || buttonType?.[`${oem[entity]}:allocation`] == 1)">
              <component :is="getComponentName('allocation')" />
            </template>
            <template v-if="buttonType?.[`${oem[entity]}:allocation`] == 0 || buttonType?.[`${oem[entity]}:allocation`] == 2">
              {{ buttonTexts?.[`${oem[entity]}:allocation`] }}
            </template>
          </jw-button>
          <!-- 线索池E -->
          <!-- 客户S -->
          <jw-button v-if="b.value == `${oem[entity]}:bingDataSync`" :disabled="b.disabled" @click="bingSyncData" :loading="data.syncLoading" type="text" size="small" :class="['normal-btn', { 'disabled-btn': b.disabled }]">
            <template #icon v-if="buttonIcons?.[`${oem[entity]}:bingDataSync`] && (buttonType?.[`${oem[entity]}:bingDataSync`] == 0 || buttonType?.[`${oem[entity]}:bingDataSync`] == 1)">
              <component :is="getComponentName('bingDataSync')" />
            </template>
            <template v-if="buttonType?.[`${oem[entity]}:bingDataSync`] == 0 || buttonType?.[`${oem[entity]}:bingDataSync`] == 2">
              {{ buttonTexts?.[`${oem[entity]}:bingDataSync`] }}
            </template>
          </jw-button>
          <jw-button v-if="b.value == `${oem[entity]}:bingUserInviteSync`" :disabled="b.disabled" type="text" size="small" :class="['normal-btn', { 'disabled-btn': b.disabled }]" @click="bingUserInviteSync" :loading="data.syncLoading">
            <template #icon v-if="buttonIcons?.[`${oem[entity]}:bingUserInviteSync`] && (buttonType?.[`${oem[entity]}:bingUserInviteSync`] == 0 || buttonType?.[`${oem[entity]}:bingUserInviteSync`] == 1)">
              <component :is="getComponentName('bingUserInviteSync')" />
            </template>
            <template v-if="buttonType?.[`${oem[entity]}:bingUserInviteSync`] == 0 || buttonType?.[`${oem[entity]}:bingUserInviteSync`] == 2">
              {{ buttonTexts?.[`${oem[entity]}:bingUserInviteSync`] }}
            </template>
          </jw-button>
          <!-- 华映资本特殊处理---新增商机入口 -->
          <jw-button v-if="b.value == `${oem[entity]}:clueAdvancement`" :disabled="b.disabled" type="text" size="small" :class="['normal-btn', { 'disabled-btn': b.disabled }]" @click="addOp">
            <template #icon v-if="buttonIcons?.[`${oem[entity]}:clueAdvancement`] && (buttonType?.[`${oem[entity]}:clueAdvancement`] == 0 || buttonType?.[`${oem[entity]}:clueAdvancement`] == 1)">
              <component :is="getComponentName('clueAdvancement')" />
            </template>
            <template v-if="buttonType?.[`${oem[entity]}:clueAdvancement`] == 0 || buttonType?.[`${oem[entity]}:clueAdvancement`] == 2">
              {{ buttonTexts?.[`${oem[entity]}:clueAdvancement`] }}
            </template>
          </jw-button>
          <!-- 客户S -->
          <!-- 自定义对象详情特殊按钮 -->
          <!-- UI后台详情 -->
          <jw-button :key="i" v-if="b.value == `${oem[entity]}:bingUserInviteUrlSync`" type="text" size="small" class="normal-btn" @click="bingUserInviteUrlSync">
            <template #icon v-if="buttonIcons?.[`${oem[entity]}:bingUserInviteUrlSync`] && (buttonType?.[`${oem[entity]}:bingUserInviteUrlSync`] == 0 || buttonType?.[`${oem[entity]}:bingUserInviteUrlSync`] == 1)">
              <component :is="buttonIcons?.[`${oem[entity]}:bingUserInviteUrlSync`]" />
            </template>
            <template v-if="buttonType?.[`${oem[entity]}:bingUserInviteUrlSync`] == 0 || buttonType?.[`${oem[entity]}:bingUserInviteUrlSync`] == 2">
              {{ buttonTexts?.[`${oem[entity]}:bingUserInviteUrlSync`] }}
            </template>
          </jw-button>
        </template>
      </template>
      <!-- 更多按钮 -->
      <template v-if="buttons.length">
        <xl-tree-member-modal ref="memberRef" @cb="getVal" :tree="{ checkDepartment: false, isAll: true }">
          <div style="width: 0; height: 0"></div>
        </xl-tree-member-modal>
        <jw-dropdown trigger="click" v-if="isShowMoreIcon" :popup-container="`.comp-ly-buttons${randomString}`" class="more-btn-dropdown">
          <jw-button type="text" size="small" class="more-btn normal-btn"><qfei-icon-more-applications-outlined /></jw-button>
          <template #content>
            <template v-for="(b, i) in buttons" :key="i">
              <template v-if="i >= buttonNumber">
                <!-- ---------------------公共按钮--所有对象都有的 S---------------------------->
                <!-- 编辑 -->
                <jw-doption v-if="b.value == `${oem[entity]}:edit`" :disabled="b.disabled">
                  <jw-space @click="toAllEdit">
                    <component :is="getComponentName('edit')" v-if="getButtonIcons('edit')" />
                    <span v-if="buttonType?.[`${oem[entity]}:edit`] == 0 || buttonType?.[`${oem[entity]}:edit`] == 2">
                      {{ buttonTexts?.[`${oem[entity]}:edit`] }}
                    </span>
                  </jw-space>
                </jw-doption>
                <!-- 复制 -->
                <jw-doption @click="copyObject" v-if="b.value == `${oem[entity]}:copy`">
                  <jw-space class="hand">
                    <component :is="getComponentName('copy')" v-if="getButtonIcons('copy')" />
                    <span v-if="buttonType?.[`${oem[entity]}:copy`] == 0 || buttonType?.[`${oem[entity]}:copy`] == 2">
                      {{ buttonTexts?.[`${oem[entity]}:copy`] }}
                    </span>
                  </jw-space>
                </jw-doption>
                <!-- 转移 -->
                <jw-doption @click="transferData" :disabled="b.disabled" v-if="b.value == `${oem[entity]}:transfer`">
                  <jw-space :class="{ hand: !b.disabled }">
                    <component :is="getComponentName('transfer')" v-if="getButtonIcons('transfer')" />
                    <span v-if="buttonType?.[`${oem[entity]}:transfer`] == 0 || buttonType?.[`${oem[entity]}:transfer`] == 2">
                      {{ buttonTexts?.[`${oem[entity]}:transfer`] }}
                    </span>
                  </jw-space>
                </jw-doption>
                <!-- 分享 -->
                <jw-doption @click="toShare" :disabled="b.disabled" v-if="b.value == `${oem[entity]}:share`">
                  <jw-space :class="{ hand: !b.disabled }">
                    <component :is="getComponentName('share')" v-if="getButtonIcons('share')" />
                    <span v-if="buttonType?.[`${oem[entity]}:share`] == 0 || buttonType?.[`${oem[entity]}:share`] == 2">
                      {{ buttonTexts?.[`${oem[entity]}:share`] }}
                    </span>
                  </jw-space>
                </jw-doption>
                <!-- 作废 -->
                <template v-if="entity == 2 || entity == 3">
                  <template v-if="b.value == `${oem[entity]}:invalidate`">
                    <jw-doption :disabled="b.disabled" v-if="(entity == 2 && !data.customerIsDelete) || (entity == 3 && !data.opportunityIsDelete)" style="background-color: var(--color-fill-2)">
                      <jw-tooltip :content="$t(entity == 2 ? 'tips.costomerEsc' : 'tips.opportunityEsc')" position="left" mini>
                        <jw-space style="cursor: not-allowed">
                          <component :is="getComponentName('invalidate')" v-if="getButtonIcons('invalidate')" />
                          <span v-if="buttonType?.[`${oem[entity]}:invalidate`] == 0 || buttonType?.[`${oem[entity]}:invalidate`] == 2">{{ buttonTexts?.[`${oem[entity]}:invalidate`] }}</span>
                        </jw-space>
                      </jw-tooltip>
                    </jw-doption>
                    <jw-doption v-else :disabled="b.disabled">
                      <jw-space @click="invalidateButton">
                        <component :is="getComponentName('invalidate')" v-if="getButtonIcons('invalidate')" />
                        <span v-if="buttonType?.[`${oem[entity]}:invalidate`] == 0 || buttonType?.[`${oem[entity]}:invalidate`] == 2">{{ buttonTexts?.[`${oem[entity]}:invalidate`] }}</span>
                      </jw-space>
                    </jw-doption>
                  </template>
                </template>
                <template v-else>
                  <jw-doption @click="invalidateButton" v-if="b.value == `${oem[entity]}:invalidate`" :disabled="b.disabled">
                    <jw-space class="hand">
                      <component :is="getComponentName('invalidate')" v-if="getButtonIcons('invalidate')" />
                      <span v-if="buttonType?.[`${oem[entity]}:invalidate`] == 0 || buttonType?.[`${oem[entity]}:invalidate`] == 2">
                        {{ buttonTexts?.[`${oem[entity]}:invalidate`] }}
                      </span>
                    </jw-space>
                  </jw-doption>
                </template>
                <!-- 删除 -->
                <jw-doption @click="deleteObject" :disabled="b.disabled" v-if="b.value == `${oem[entity]}:delete`">
                  <jw-space :class="{ hand: !b.disabled }">
                    <component :is="getComponentName('delete')" v-if="getButtonIcons('delete')" />
                    <span v-if="buttonType?.[`${oem[entity]}:delete`] == 0 || buttonType?.[`${oem[entity]}:delete`] == 2">
                      {{ buttonTexts?.[`${oem[entity]}:delete`] }}
                    </span>
                  </jw-space>
                </jw-doption>
                <!-- ---------------------公共按钮--所有对象都有的 E---------------------------->
                <!-- ---------------------特殊差异按钮--某个对象才有 S---------------------------->
                <jw-doption v-if="b.value == `${oem[entity]}:addRedReversal`" :disabled="b.disabled">
                  <jw-space @click="addRedReversal">
                    <component :is="getComponentName('addRedReversal')" v-if="getButtonIcons('addRedReversal')" />
                    <span v-if="buttonType?.[`${oem[entity]}:addRedReversal`] == 0 || buttonType?.[`${oem[entity]}:addRedReversal`] == 2">
                      {{ buttonTexts?.[`${oem[entity]}:addRedReversal`] }}
                    </span>
                  </jw-space>
                </jw-doption>
                <!--销售线索-->
                <!-- 转化 -->
                <jw-doption @click="conversion" :disabled="b.disabled" v-if="b.value == `${oem[entity]}:transform`">
                  <jw-space :class="{ hand: !b.disabled }">
                    <component :is="getComponentName('transform')" v-if="getButtonIcons('transform')" />
                    <span v-if="buttonType?.[`${oem[entity]}:transform`] == 0 || buttonType?.[`${oem[entity]}:transform`] == 2">
                      {{ buttonTexts?.[`${oem[entity]}:transform`] }}
                    </span>
                  </jw-space>
                </jw-doption>
                <!-- 退回 -->
                <jw-doption @click="returnClue" :disabled="b.disabled" v-if="b.value == `${oem[entity]}:return`">
                  <jw-space :class="{ hand: !b.disabled }">
                    <component :is="getComponentName('return')" v-if="getButtonIcons('return')" />
                    <span v-if="buttonType?.[`${oem[entity]}:return`] == 0 || buttonType?.[`${oem[entity]}:return`] == 2">
                      {{ buttonTexts?.[`${oem[entity]}:return`] }}
                    </span>
                  </jw-space>
                </jw-doption>
                <!--【领取】【分配】 线索池 -->
                <!-- 领取 -->
                <jw-doption @click="collectionClue" v-if="b.value == `${oem[entity]}:receive`" :disabled="b.disabled">
                  <jw-space class="hand">
                    <component :is="getComponentName('receive')" v-if="getButtonIcons('receive')" />
                    <span v-if="buttonType?.[`${oem[entity]}:receive`] == 0 || buttonType?.[`${oem[entity]}:receive`] == 2">
                      {{ buttonTexts?.[`${oem[entity]}:receive`] }}
                    </span>
                  </jw-space>
                </jw-doption>
                <!-- 分配 -->
                <jw-doption @click="distributionClue" v-if="b.value == `${oem[entity]}:allocation`" :disabled="b.disabled">
                  <jw-space class="hand">
                    <component :is="getComponentName('allocation')" v-if="getButtonIcons('allocation')" />
                    <span v-if="buttonType?.[`${oem[entity]}:allocation`] == 0 || buttonType?.[`${oem[entity]}:allocation`] == 2">
                      {{ buttonTexts?.[`${oem[entity]}:allocation`] }}
                    </span>
                  </jw-space>
                </jw-doption>
                <!-- 客户S -->
                <jw-doption v-if="b.value == `${oem[entity]}:bingDataSync`" :disabled="b.disabled">
                  <jw-space @click="bingSyncData">
                    <component :is="getComponentName('bingDataSync')" v-if="getButtonIcons('bingDataSync')" />
                    <span v-if="buttonType?.[`${oem[entity]}:bingDataSync`] == 0 || buttonType?.[`${oem[entity]}:bingDataSync`] == 2">{{ buttonTexts?.[`${oem[entity]}:bingDataSync`] }}</span>
                  </jw-space>
                </jw-doption>
                <!-- 邀请数据同步 -->
                <jw-doption v-if="b.value == `${oem[entity]}:bingUserInviteSync`" :disabled="b.disabled">
                  <jw-space @click="bingUserInviteSync">
                    <component :is="getComponentName('bingUserInviteSync')" v-if="getButtonIcons('bingUserInviteSync')" />
                    <span v-if="buttonType?.[`${oem[entity]}:bingUserInviteSync`] == 0 || buttonType?.[`${oem[entity]}:bingUserInviteSync`] == 2">{{ buttonTexts?.[`${oem[entity]}:bingUserInviteSync`] }}</span>
                  </jw-space>
                </jw-doption>
                <jw-doption v-if="b.value == `${oem[entity]}:clueAdvancement`" :disabled="b.disabled">
                  <jw-space @click="addOp">
                    <component :is="getComponentName('clueAdvancement')" v-if="getButtonIcons('clueAdvancement')" />
                    <span v-if="buttonType?.[`${oem[entity]}:clueAdvancement`] == 0 || buttonType?.[`${oem[entity]}:clueAdvancement`] == 2">{{ buttonTexts?.[`${oem[entity]}:clueAdvancement`] }}</span>
                  </jw-space>
                </jw-doption>
                <!-- 客户E -->
                <!-- 商机 S -->
                <jw-doption v-if="b.value == `${oem[entity]}:addCallPayment`" :disabled="b.disabled">
                  <jw-space @click="openAddModal(1)">
                    <component :is="getComponentName('addCallPayment')" v-if="getButtonIcons('addCallPayment')" />
                    <span v-if="buttonType?.[`${oem[entity]}:addCallPayment`] == 0 || buttonType?.[`${oem[entity]}:addCallPayment`] == 2">
                      {{ buttonTexts?.[`${oem[entity]}:addCallPayment`] }}
                    </span>
                  </jw-space>
                </jw-doption>
                <jw-doption v-if="b.value == `${oem[entity]}:addProtocol`" :disabled="b.disabled">
                  <jw-space @click="openAddModal(2)">
                    <component :is="getComponentName('addProtocol')" v-if="getButtonIcons('addProtocol')" />
                    <span v-if="buttonType?.[`${oem[entity]}:addProtocol`] == 0 || buttonType?.[`${oem[entity]}:addProtocol`] == 2">
                      {{ buttonTexts?.[`${oem[entity]}:addProtocol`] }}
                    </span>
                  </jw-space>
                </jw-doption>
                <!-- 商机E -->
                <!-- 自定义对象详情特殊按钮 -->
                <!-- UI后台详情 -->
                <jw-doption :key="i" v-if="b.value == `${oem[entity]}:bingUserInviteUrlSync`">
                  <jw-space @click="bingUserInviteUrlSync">
                    <component :is="buttonIcons?.[`${oem[entity]}:bingUserInviteUrlSync`]" v-if="buttonIcons?.[`${oem[entity]}:bingUserInviteUrlSync`] && (buttonType?.[`${oem[entity]}:bingUserInviteUrlSync`] == 0 || buttonType?.[`${oem[entity]}:bingUserInviteUrlSync`] == 1)" />
                    <span v-if="buttonType?.[`${oem[entity]}:bingUserInviteUrlSync`] == 0 || buttonType?.[`${oem[entity]}:bingUserInviteUrlSync`] == 2">{{ buttonTexts?.[`${oem[entity]}:bingUserInviteUrlSync`] }}</span>
                  </jw-space>
                </jw-doption>
                <!-- ---------------------特殊差异按钮--某个对象才有 E---------------------------->
              </template>
            </template>
          </template>
        </jw-dropdown>
      </template>
    </jw-space>
    <!-- 编辑弹窗 -->
    <fh-add-edit ref="addEditRef" @cb="btnDialogEvent('init', false)" />
    <!-- 转化线索  -->
    <clue-conversion ref="conversionRef"></clue-conversion>
    <!-- 转移线索  -->
    <xl-transfer ref="transferRef" :type="props.entity" @cb="btnDialogEvent('handleCancel')"></xl-transfer>
    <!-- 退回 -->
    <xl-return ref="returnRef" @cb="btnDialogEvent('handleCancel')"></xl-return>
    <!--分配-->
    <xl-distribution ref="distributionRef" @cb="btnDialogEvent('handleCancel')"></xl-distribution>
    <!-- 转移线索池 S-->
    <xl-pool-transfer ref="transferPoolRef" @cb="btnDialogEvent('handleCancel')" :type="props.entity"></xl-pool-transfer>
  </div>
</template>

<script setup>
import { computed, inject, onMounted, reactive, ref, watch, provide } from 'vue';
import { Message, Modal } from '@arco-design/web-vue';
import { clientService, publicService, opportunityService } from '@/api/';
import { tools } from '@/utils/tools';
import { useRouter } from 'vue-router';
import { objEntityMapping, HongChongInfo, computingStatus } from '@/utils/const';
import { useUserStore } from '@/store';
import { useI18n } from 'vue-i18n';
import useButtonEvent from '@/hooks/button-event.js';
import ClueConversion from '@/views/leads/components/clue-conversion/index.vue';
import { QfeiIconMoreApplicationsOutlined } from '@qfei-design/icons-vue';
const router = useRouter();
console.log('1-开始创建组件-setup');
const emits = defineEmits(['cb']);
const data = reactive({
  id: inject('detailParams')?.id,
  permission: inject('detailParams')?.permission,
  detailAllFields: inject('detailParams')?.detailAllFields,
  msqlTaskId: null, //是否可以转化商机
  shareLoading: false,
  /**********客户S*********** */
  customerId: inject('detailParams')?.customerId,
  // customerSize: inject('detailParams')?.customerSize,
  customerIsDelete: false, //客户是否删除
  syncLoading: false,
  input_rbKcJb: inject('defaultParams')?.input_rbKcJb,
  /**********商机S*********** */
  account_id: inject('defaultParams')?.account_id,
  customPermission: true,
  /************线索池********** */
  poolId: inject('detailParams')?.poolId,
  // 报价单Id
  historyPriceId: inject('detailParams')?.historyPriceId,
  layoutMainField: inject('detailParams')?.layoutMainField,
  viewId: inject('detailParams')?.viewId
});
// 用户多层级挂载
const randomString = tools.randomString(10);
const name = ref();
// 放在更多按钮中的标识集合，目前是16个，之后如果添加按钮时需要往该数组中添加
const moreButtonList = ref(['edit', 'copy', 'transfer', 'share', 'invalidate', 'delete', 'transform', 'return', 'receive', 'allocation', 'bingDataSync', 'bingUserInviteSync', 'clueAdvancement', 'addCallPayment', 'addProtocol', 'bingUserInviteUrlSync', 'addRedReversal']);
const props = defineProps({
  entity: {
    type: [String, Number]
  },
  allButtonsList: {
    type: Array,
    default: () => []
  },
  buttonNum: {
    type: [String, Number]
  },
  detailAllFields: {
    type: Object,
    default() {
      return {};
    }
  },
  // 计算状态
  computedError: {
    type: Object,
    default() {
      return {};
    }
  }
});
const computedInfo = computed(() => props.computedError);
const oem = ref(JSON.parse(JSON.stringify(objEntityMapping)));
console.log(191, data, name, props);
const { t } = useI18n();
const { userInfo } = useUserStore(); //用户信息
const addEditRef = ref(); // 编辑弹窗
const conversionRef = ref();
const transferRef = ref(); //转移
const returnRef = ref(); //退回
const distributionRef = ref(); // 分配线索池
const transferPoolRef = ref(); //线索池转移

// 按钮的事件hooks
const { collection, isPoolManager, invalidate, shareRowData, clueReturn, deleteObj, getTaskId } = useButtonEvent();
/**************************************头部按钮开始************************************************************ */
//所有按钮
const buttonIcons = ref([]);
const buttonTexts = ref([]);
const buttonType = ref([]);
const buttons = ref([]);
// const buttonNumber = computed(() => Number(props.buttonNum));
const buttonNumber = computed({
  get() {
    return Number(props.buttonNum); // 默认从 props 获取值
  },
  set(newValue) {
    return Number(newValue);
  }
});
const formatButtons = (datas) => {
  buttonIcons.value = tools.getIconsByEntity(userInfo?.menus?.entityResources, props.entity);
  buttonTexts.value = tools.getOptTextsByEntity(userInfo?.menus?.entityResources, props.entity);
  buttonType.value = tools.getShowTypeByEntity(userInfo?.menus?.entityResources, props.entity);
  let _buttons = [];
  datas.map((d) => {
    if (d.type == '40' && data.permission == 1 && userInfo?.roles?.indexOf(d.value) > -1) {
      d.disabled = false;
      if (props.entity == 1) {
        if (d.value != 'clue:transform' || (!data.detailAllFields?.customerId?.value && data.detailAllFields?.clueStatus != 2)) {
          _buttons.push(d);
        }
      } else {
        // 红冲按钮
        const hcCondition = d.value === `${props.entity}:addRedReversal` && props.detailAllFields[HongChongInfo.noteInfo.fieldKey] == HongChongInfo.noteInfo.fieldValue;
        if (hcCondition) {
          _buttons.push(d);
        }
        // 其他按钮
        if (d.value !== `${props.entity}:addRedReversal`) {
          _buttons.push(d);
        }

        // _buttons.push(d);
      }
    }
  });
  // 审批过滤
  console.log('formatButtons', _buttons);
  if (_buttons.length && props.entity != 101) {
    _buttons = filterBottons(_buttons);
  }
  if (buttonNumber.value > _buttons.length) {
    buttonNumber.value = _buttons.length;
  }
  // 计算状态1 审批处理中3  只显示复制按钮
  if (computingStatus.includes(Number(computedInfo.value?.[0]?.status))) {
    const entity = props.entity >= 200 ? props.entity : oem.value[props.entity];
    // buttons.value = _buttons?.filter((item) => item.value == `${entity}:copy`) || [];
    buttons.value = _buttons?.map((item) => {
      if (`${entity}:copy` == item?.value) {
        return { ...item, disabled: false };
      }
      return { ...item, disabled: true };
    });
    return;
  }
  buttons.value = _buttons;
};

// 审批过滤
const filterBottons = (_buttons) => {
  console.log('filterBottons', _buttons);
  const entity = props.entity >= 200 ? props.entity : oem.value[props.entity];
  // 锁定
  if (props.detailAllFields?.locked) {
    // _buttons = _buttons.filter((item) => `${entity}:edit` != item.value && `${entity}:transfer` != item?.value && `${entity}:invalidate` != item?.value);
    _buttons = _buttons.map((item) => {
      if ([`${entity}:edit`, `${entity}:transfer`, `${entity}:invalidate`].includes(item?.value)) {
        return { ...item, disabled: true };
      }
      return item;
    });

    // 销售线索
    if (props.entity == 1) {
      // _buttons = _buttons.filter((item) => `${entity}:transform` != item?.value && `${entity}:return` != item?.value);
      _buttons = _buttons.map((item) => {
        if ([`${entity}:transform`, `${entity}:return`].includes(item?.value)) {
          return { ...item, disabled: true };
        }
        return item;
      });
    }
  } else {
    // 非锁定  且 （审批中 或 变更中）
    if (props.detailAllFields?.status == 1 || props.detailAllFields?.status == 6) {
      // _buttons = _buttons.filter((item) => `${entity}:transfer` != item?.value && `${entity}:invalidate` != item?.value);
      _buttons = _buttons.map((item) => {
        if ([`${entity}:transfer`, `${entity}:invalidate`].includes(item?.value)) {
          return { ...item, disabled: true };
        }
        return item;
      });
      // 过滤 销售线索   退回  转化
      if (props.entity == 1) {
        // _buttons = _buttons.filter((item) => `${entity}:return` != item?.value && `${entity}:transform` != item?.value);
        _buttons = _buttons.map((item) => {
          if ([`${entity}:return`, `${entity}:transform`].includes(item?.value)) {
            return { ...item, disabled: true };
          }
          return item;
        });
      }
    }
  }
  return _buttons;
};

// 按钮的动态组件
const getComponentName = (type) => {
  // 根据实体值获取对应的组件名称
  return buttonIcons.value[`${oem.value[props.entity]}:${type}`];
};
// 是否展示按钮
const getButtonIcons = (type) => {
  return buttonIcons.value?.[`${oem.value[props.entity]}:${type}`] && (buttonType.value?.[`${oem.value[props.entity]}:${type}`] == 0 || buttonType.value?.[`${oem.value[props.entity]}:${type}`] == 1);
};
// 是否展示更多按钮
const isShowMoreIcon = computed(() => {
  // 详情中的其他页签中也会有按钮，返回在同一个集合中，所以需要过滤掉只在详情页更多按钮中才会展示的集合
  const moreListLength = buttons.value.filter((v) => moreButtonList.value?.includes(v.value?.split(':')[1]));
  if (moreListLength.length - buttonNumber.value > 0) {
    return true;
  } else {
    return false;
  }
});
const memberRef = ref();
const toShare = () => {
  memberRef.value.openDialog();
};

//红冲定制
const addRedReversal = () => {
  const setObjParams = {
    //设置当前对象信息
    label: props.detailAllFields[data.layoutMainField.fieldKey] || '',
    value: data.id || '', // 当前数据id
    fieldKey: '',
    fieldExt: props.entity //当前对象id
  };

  const params = {
    type: 30,
    viewId: HongChongInfo.viewId,
    entity: props?.entity,
    getEntityObj: setObjParams
  };

  console.log('红冲申请参数33', params);

  addEditRef.value?.open(params);
};

//头部操作类的回调
const toAllEdit = () => {
  // 编辑
  const params = { id: data.id, type: 40, viewId: data.viewId || -1, entity: props?.entity };
  // 弹窗编辑
  addEditRef.value?.open(params);
};
// 人员弹窗是否可以选择部门
const tree = ref({
  checkDepartment: false,
  isAll: true
});
// 全部对象--分享功能
const getVal = async (v) => {
  console.log('角色员工人员选择查看:', v);
  // 选择人员后，调添加人员接口，参数都在v中，按需去V中取
  const userIds = v?.userList?.map((u) => u.id);
  const params = { userIds, id: props.entity == 6 && data.historyPriceId ? data.historyPriceId : data.id, type: props.entity };
  data.shareLoading = true;
  await shareRowData(params);
  data.shareLoading = false;
};
// 线索转化为客户或者转化为客户和商机
const conversion = async () => {
  await getMsqlTaskId();
  conversionRef.value.open();
};
// 根据主键查询线索
const getMsqlTaskId = async () => {
  try {
    const params = {
      id: data.id
    };
    await getTaskId(params).then((res) => {
      if (res) {
        data.msqlTaskId = res.result;
      }
    });
  } catch (e) {
    Message.error(e.message || e.statusText || t('获取数据失败'));
  }
};
//作废
const invalidateButton = () => {
  Modal.confirm({
    titleAlign: 'start',
    width: 400,
    simple: false,
    title: t('作废'),
    content: t('tips.markData'),
    okText: t('确定'),
    cancelText: t('取消'),
    onOk: async () => {
      let params = {};
      if ([1, 101].includes(props.entity)) {
        params = {
          entity: props.entity,
          clueIds: [data.id]
        };
      } else if ([2, 3, 8, 10, 13].includes(props.entity)) {
        params = { entity: props.entity, id: data.id };
      } else if (props.entity == 6) {
        params = {
          entity: props.entity,
          id: (params.id = data.historyPriceId ? data.historyPriceId : data.id)
        };
      } else if (props.entity == 12 || props.entity >= 200) {
        params = {
          entity: props.entity,
          businessId: data.id
        };
      }
      await invalidateApi(params);
    }
  });
};

// 所有作废按钮的逻辑(最老的作废接口)
const invalidateApi = async (params) => {
  try {
    await invalidate(params).then((res) => {
      if (res) {
        emits('cb', 'handleCancel');
      }
    });
  } catch (e) {
    console.log(e);
  }
};
// 转移事件
const transferData = () => {
  if (props.entity == 101) {
    transferPoolClue();
  } else {
    transferClue();
  }
};
//转移其他对象
const transferClue = () => {
  const params = {
    title: t('转移'),
    ids: [props.entity && data.historyPriceId ? data.historyPriceId : data.id],
    changeFlag: props.entity == 2 || props.entity == 3 ? true : false //是否可变更其他负责人
  };
  transferRef.value.transferShow(params);
};
//退回
const returnClue = async () => {
  try {
    await clueReturn({ businessIds: [data.id] }).then((res) => {
      if (res) {
        const params = {
          title: t('退回'),
          ids: [data.id]
        };
        returnRef.value.returnShow(params);
      }
    });
  } catch (e) {
    console.log(e);
  }
};
const copyObject = () => {
  const params = { id: data.id, type: 30, viewId: data.viewId, entity: props?.entity, copy: 1 };
  addEditRef.value?.open(params);
};
// 按钮组件中的弹窗的回调事件
const btnDialogEvent = (type, params) => {
  emits('cb', type, params);
};
// 删除弹窗
const deleteObject = () => {
  Modal.confirm({
    titleAlign: 'start',
    width: 400,
    simple: false,
    title: t('温馨提示'),
    content: t('删除后该数据将不再可见，是否确认？'),
    onOk: () => {
      doDeleteObject();
    }
  });
};
// 删除api
const doDeleteObject = async () => {
  try {
    const params = {
      entity: props.entity,
      businessId: data.id
    };
    await deleteObj(params).then((res) => {
      if (res) {
        emits('cb', 'handleCancel');
      }
    });
  } catch (e) {
    console.log(e);
  }
};

/***********************线索池按钮 S************************** */
// 领取池线索
const collectionClue = () => {
  try {
    const params = {
      businessIds: [data.id],
      poolId: data.poolId
    };
    collection(params).then((res) => {
      if (res) {
        emits('cb', 'handleCancel');
      }
    });
  } catch (e) {
    console.log(e);
  }
};
//线索池转移
const transferPoolClue = () => {
  const params = {
    businessIds: [data.id],
    poolId: data.poolId
  };
  transferPoolRef.value.getOptions(data.poolId);
  transferPoolRef.value.transferShow(params);
};

//线索池分配
const distributionClue = async () => {
  const result = await isPoolManager({
    poolId: data.poolId
  });
  if (result) {
    const params = {
      businessIds: [data.id],
      poolId: data.poolId,
      title: t('分配')
    };
    distributionRef.value.transferShow(params);
  } else {
    Message.error(t('您非线索池管理员，不可分配线索'));
  }
};
/***********************线索池按钮 E************************** */
/***********************************客户特殊逻辑 S***************************************** */
// 检查客户是否可以作废
const checkIsDelete = () => {
  if (props.entity == 2) {
    customerCheck();
  } else if (props.entity == 3) {
    opportunityCheck();
  }
};
// 检查客户是否可以作废
const customerCheck = async () => {
  try {
    const params = { id: data.id };
    const json = await clientService.customerCheck(params);
    if (!json.error) {
      data.customerIsDelete = json.result;
    }
  } catch (e) {
    Message.error(e.message || e.statusText || t('获取数据失败'));
  }
};
// 检查商机是否可以作废
const opportunityCheck = async () => {
  try {
    const params = { id: data.id };
    const json = await opportunityService.opportunityCheck(params);
    if (!json.error) {
      data.opportunityIsDelete = json.result;
    }
  } catch (e) {
    Message.error(e.message || e.statusText || t('获取数据失败'));
  }
};
console.log(764, props.detailAllFields);
// 新增商机
const addOp = () => {
  //商机
  // router.push({
  //   name: 'addOpportunity',
  //   params: { type: 30, viewId: -1, entity: 3 },
  //   query: { customerId: data.customerId }
  // });

  const setObjParams = {
    //设置当前对象信息
    label: props.detailAllFields?.customerName || '',
    value: data.customerId || '',
    fieldKey: '',
    fieldExt: 2 //当前对象id
  };

  const params = { getEntityObj: setObjParams, type: 30, viewId: -1, entity: 3 };
  // 弹窗编辑
  addEditRef.value?.open(params);
};
// UI后台详情《从自定义对象详情中迁移过来的》
const bingUserInviteUrlSync = async () => {
  data.syncLoading = true;
  try {
    const params = {
      type: props.entity,
      ids: [data.id],
      isUserInvite: true,
      isCustomer: false
    };
    const json = await publicService.getUrl(params);
    if (!json.error) {
      Message.success('成功');
      emits('cb', 'init');
      setTimeout(() => {
        window.open(json?.result, '_blank');
      }, 1000);
    } else {
      Message.error(json.error?.msg || '失败!');
    }
    data.syncLoading = false;
  } catch (e) {
    data.syncLoading = false;
    Message.error(e.message || e.statusText || '失败!');
  }
};
//数据同步
const bingSyncData = async () => {
  data.syncLoading = true;
  try {
    const params = {
      type: props.entity,
      ids: props.entity == 2 ? [data.input_rbKcJb] : [data.account_id]
    };
    const json = await publicService.refreshData(params);
    if (!json.error) {
      Message.success('数据同步中，同步完成后将自动刷新数据');
      emits('cb', 'init');
    } else {
      Message.error(json.error?.msg || '数据同步失败，请重试!');
    }
    data.syncLoading = false;
  } catch (e) {
    data.syncLoading = false;
    Message.error(e.message || e.statusText || '数据同步失败，请重试!');
  }
};

//邀请数据同步
const bingUserInviteSync = async () => {
  data.syncLoading = true;
  try {
    const params = {
      type: props.entity,
      ids: [data?.id],
      isUserInvite: true,
      isCustomer: true
    };
    const json = await publicService.refreshData(params);
    if (!json.error) {
      Message.success('邀请数据同步中，同步完成后将自动刷新数据');
      emits('cb', 'init');
    } else {
      Message.error(json.error?.msg || '数据同步失败，请重试!');
    }
    data.syncLoading = false;
  } catch (e) {
    data.syncLoading = false;
    Message.error(e.message || e.statusText || '数据同步失败，请重试!');
  }
};

/***********************************客户特殊逻辑 E***************************************** */
/*******************************商机详情的逻辑**************************************** */
// 判断商机关联的客户是否有权限(负责人或协作人)
const getCustomPermission = async (customerId, type) => {
  try {
    const params = {
      entity: type,
      id: customerId
    };
    const json = await opportunityService.getCustomPermission(params);
    console.log(237, json);
    if (!json.error) {
      data.customPermission = json.result;
    } else {
      Message.error(json.error?.msg || t('获取客户协作权限失败'));
    }
  } catch (e) {
    console.log(e);
    Message.error(e.message || e.statusText || t('获取客户协作权限失败'));
  }
};

//华映资本--特殊处理--新增订单及合同入口
const openAddModal = async (type) => {
  console.log(type); // type:1：销售订单，销售合同
  // 商机传递关联的客户ID和客户的entity
  if (!data?.detailAllFields?.customerId?.value) {
    //商机未关联客户
    Message.warning(type == 1 ? t('tips.addOrderError') : t('tips.addContractError'));
    return;
  } else {
    await getCustomPermission(data?.detailAllFields?.customerId?.value, 2);
    if (!data.customPermission) {
      // 商机关联了客户，但是没有客户操作权限
      Message.warning(t('tips.noPrimisson'));
      return;
    }
  }

  if (type == 1) {
    router.push({
      name: 'update-order',
      params: { type: 30, viewId: -1, entity: 10, id: -1 },
      query: { customerId: data?.detailAllFields?.customerId?.value, opportunityId: data.id }
    });
  } else if (type == 2) {
    router.push({
      name: 'update-contract',
      params: { type: 30, viewId: -1, entity: 8, id: -1 },
      query: { customerId: data?.detailAllFields?.customerId?.value, opportunityId: data.id }
    });
  }
  provide('globalParams', {
    id: computed(() => data.id)
  });
};
// 线索转化----是否可以转化商机
provide('msqlTaskId', {
  id: computed(() => data.msqlTaskId)
});
onMounted(() => {});
watch(
  () => props.allButtonsList,
  (v) => {
    console.log('allButtonsList-0', v);
    formatButtons(v);
  },
  {
    deep: true,
    immediate: true
  }
);
watch(
  () => props.entity,
  (v) => {
    if (v == 2 || v == 3) {
      checkIsDelete();
    }
    if (v >= 200) {
      oem.value[v] = v;
    }
  },
  {
    deep: true,
    immediate: true
  }
);
</script>
<style scoped lang="less">
@import './index.less';
</style>

<style lang="less">
.more-btn-dropdown {
  .arco-space-item {
    height: 28px;
    line-height: 28px;

    span {
      display: inline-block;
      height: 28px;
    }
  }
}
</style>
